import PhotoSwipeLightbox from '../src/photoswipe-lightbox.esm.min'

window.photoswipeInit = function() {
    const links = Array.from(document.querySelectorAll('a.photoswipe-trigger'))

    const preloadImage = (src) => {
        return new Promise(resolve => {
            const img = new Image()
            img.src = src
            img.onload = () => {
                resolve({
                    src,
                    width: img.naturalWidth,
                    height: img.naturalHeight
                })
            }
            img.onerror = () => {
                resolve({
                    src,
                    width: 1024,
                    height: 768
                })
            }
        })
    }

    Promise.all(links.map(link => preloadImage(link.href))).then(dataSource => {
        const lightbox = new PhotoSwipeLightbox({
            pswpModule: () => import('../src/photoswipe.esm.min'),
            dataSource,
            bgOpacity: 0.9,
            padding: { top: 24, bottom: 24, left: 8, right: 8 },
        })

        lightbox.init()

        links.forEach((link, index) => {
            link.addEventListener('click', (e) => {
                e.preventDefault()
                lightbox.loadAndOpen(index)
            })
        })
    })
}
